'use strict';

var $ = require('jquery');

function getSlides(slider) {
    return slider.find('.floating-slider-slide');
}

function moveSlidesForInfiniteSlide(slides, dir) {
    if (dir === 'next') {
        // Move first slide to the end so the user can keep going forward
        slides.last().after(slides.first());
    } else {
        // Move the last slide before the first so the user can keep going backwards
        slides.first().before(slides.last());
    }
}

function setActiveSlide(slider, dir, slides) {
    var activeSlide = $(slider).find('.active');

    if (activeSlide.length === 0 || !activeSlide.length || activeSlide.length === null) {
        // Register active slide on initial load
        slides.first().addClass('active');
    } else if (activeSlide.length >= 1 && dir === 'next') {
        // Move active class to the right
        activeSlide.removeClass('active').next('.floating-slider-slide').addClass('active');
    } else if (activeSlide.length >= 1 && dir === 'previous') {
        // Move active class to the left
        activeSlide.removeClass('active').prev('.floating-slider-slide').addClass('active');
    }

    activeSlide = $(slider).find('.active');

    return activeSlide;
}

function setActiveSlideContent(slider, active) {
    var teaserBox = slider.find('.teaser-box-floating-inner');

    //text content for active slide
    $(teaserBox).html(active.find('.inner-teaser-box').html()).hide().fadeIn(600);
}

module.exports = {
    init: function () {
        $('.floating-slider')
            .not('.loaded')
            .each(function () {
                var $el = $(this),
                    slides = getSlides($el);

                $el.setUniqueId();

                //hide arrows if only one slide
                if ($(slides).length <= 1) {
                    $el.find('.slider-arrow-wrapper').remove();
                }

                //copies first slide when only two slides
                if ($(slides).length === 2) {
                    var wrapper = $el.find('.teaser-wrapper');

                    //clone slides and add them to the end so user is able to loop
                    slides.clone().appendTo(wrapper);

                    //get the new cloned slides
                    slides = getSlides($el);
                }

                // Move the last slide before the first so the user is able to immediately go backwards
                slides.first().before(slides.last());

                setActiveSlideContent($el, setActiveSlide($el, null, slides));

                if ($el.hasClass('clp-care-tips')) {
                    $(this).addClass('float-inverted');
                }

                //show slider
                $el.addClass('loaded');
            });

        $('.slider-arrow').on('click', function () {
            var sliderArrow = $(this),
                slider = $(sliderArrow).closest('.floating-slider'),
                slides = getSlides(slider),
                dir = sliderArrow.data('direction');

            moveSlidesForInfiniteSlide(slides, dir);
            setActiveSlideContent(slider, setActiveSlide(slider, dir, slides));
        });
    }
};
